import type * as api from '@gitbook/api-client';
import { createPalette, PaletteCommandType } from '@gitbook/react-uikit';

import { apiResource, readAPICache } from '../../state';
import { flattenSpacesInOrgAllContent } from '../Organization';
import { SpaceIcon } from '../Space';

/**
 * Get a palette item for a space.
 */
export function getSpacePaletteItem(space: api.Space) {
    return {
        key: space.id,
        title: space.title,
        icon: <SpaceIcon space={space} />,
    };
}

/**
 * Simple hook for creating a palette to select a space.
 */
export function useSelectSpacePalette(props: {
    selectedSpaceId?: string;
    onSpaceSelected: (space: api.Space) => void;
    organizationId: string;
    filterSpace?: (space: api.Space) => boolean;
}) {
    const { selectedSpaceId, onSpaceSelected, organizationId, filterSpace = () => true } = props;

    return () => {
        return createPalette({
            search: { placeholder: 'Find space…' },
            groups: [
                {
                    key: 'spaces',
                    commands: () => {
                        const allContent = readAPICache(
                            apiResource('getOrganizationAllContent', { organizationId })
                        );
                        return flattenSpacesInOrgAllContent(allContent, ({ space }) => {
                            if (!filterSpace(space)) {
                                return null;
                            }
                            const baseCommand = {
                                ...getSpacePaletteItem(space),
                                trigger: async () => onSpaceSelected(space),
                            };

                            if (selectedSpaceId) {
                                return {
                                    ...baseCommand,
                                    type: PaletteCommandType.RADIO as const,
                                    selected: selectedSpaceId === space.id,
                                };
                            }

                            return baseCommand;
                        });
                    },
                },
            ],
        });
    };
}
